module.exports = __webpack_public_path__ + "static/img/logoImg.26290d2c.png";